import { render, staticRenderFns } from "./BCXTable.vue?vue&type=template&id=68743451&scoped=true"
import script from "./BCXTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXTable.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BCXTable.vue?vue&type=style&index=0&id=68743451&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68743451",
  null
  
)

export default component.exports